import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactPlaceholder from 'react-placeholder';
import { InputPlaceholder } from '@contently/toolkit';
import { get } from '../../utils/api';
import EnhancedSelect from './enhanced_select/enhanced_select';
import formatOptions from '../../utils/formatters/formatOptions';
import { handleError } from '../../utils/errors';

class ContentStrategySection extends Component {
  constructor(props) {
    super(props);

    const { audiences, pillars } = props;

    this.state = {
      pillars,
      audiences
    };
  }

  componentDidMount() {
    const { brandProfileId, onFetching, onError, audiences, pillars } = this.props;

    if (audiences.length > 0 || pillars.length > 0) return;

    onFetching('contentStrategy', true);

    return get(`/api/v1/brand_profiles/${brandProfileId}/content_strategy`)
      .then(res => {
        onFetching('contentStrategy', false);
        this.setState({
          pillars: res.pillars,
          audiences: res.audiences
        });
      })
      .catch(error => {
        handleError(error, () => onError());
      });
  }

  render() {
    const { fetching, values, errors, touched } = this.props;
    const { audiences, pillars } = this.state;

    let contentStrategySection = null;

    if (fetching || (audiences.length || pillars.length)) {
      contentStrategySection = (
        <div className="row highlight-group highlight-group-cs">
          {audiences.length > 0 && (
            <div className="sub-interaction">
              <ReactPlaceholder
                showLoadingAnimation
                customPlaceholder={<InputPlaceholder wrapperClass="row" withLabel strategy />}
                ready={!fetching}
              >
                <EnhancedSelect
                  {...this.props}
                  id="audience"
                  selectedValue={values.audience}
                  options={formatOptions(audiences)}
                  errors={errors.audience}
                  touched={touched.audience}
                  label="Audience"
                  placeholder="Select an audience"
                  noTranslate
                />
              </ReactPlaceholder>
            </div>
          )}

          {pillars.length > 0 && (
            <div className="sub-interaction">
              <ReactPlaceholder
                showLoadingAnimation
                customPlaceholder={<InputPlaceholder wrapperClass="row" withLabel strategy />}
                ready={!fetching}
              >
                <EnhancedSelect
                  {...this.props}
                  id="pillar"
                  selectedValue={values.pillar}
                  options={formatOptions(pillars)}
                  errors={errors.pillar}
                  touched={touched.pillar}
                  label="Pillar"
                  placeholder="Select a pillar"
                  noTranslate
                />
              </ReactPlaceholder>
            </div>
          )}
        </div>
      );
    }

    return <Fragment>{contentStrategySection}</Fragment>;
  }
}

ContentStrategySection.defaultProps = {
  pillars: [],
  audiences: [],
  onError: () => {},
  onFetching: () => {}
};

ContentStrategySection.propTypes = {
  fetching: PropTypes.bool.isRequired,
  brandProfileId: PropTypes.string.isRequired,
  onFetching: PropTypes.func,
  onError: PropTypes.func,
  pillars: PropTypes.array,
  audiences: PropTypes.array
};

export default ContentStrategySection;



// WEBPACK FOOTER //
// ./app/javascript/app/components/forms/content_strategy_section.jsx